<template>
  <div class="biddingDetail">
    <header>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="16"
        viewBox="0 0 20 16"
        @click="goBack()"
      >
        <g fill="#000" fill-rule="evenodd">
          <path
            d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
          />
          <path
            d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
          />
        </g>
      </svg>
      <button
        type="button"
        class="share-button"
        @click="shareFunc(salesDetails.itemImage, salesDetails.sellerItemRelationShipId, salesDetails.biddingId)"
      >{{$t("shareWithFrnds")}}</button>
    </header>
    <section class="detail-content">
      <div class="img-block">
        <img :src="salesDetails.itemImage" />
      </div>
      <div class="prod-detail">
        <div v-if="salesDetails.biddingStatus === 'STARTED'">
          <p
            class="bidder-detail"
            v-if="salesDetails.location"
          >{{$t('userIsWinning',{name:salesDetails.userName, location:salesDetails.location})}}</p>
          <p
            class="bidder-detail"
            v-else-if="salesDetails.userName"
          >{{$t('userIsWinningWithoutLoc',{name:salesDetails.userName})}}</p>
        </div>
        <div v-if="salesDetails.biddingStatus === 'CLOSED'">
          <p class="bidder-detail-closed" v-if="salesDetails.location">
            <img src="../../../assets/images/detail/ic_medal.svg" alt="profile-image" />
            {{$t('userWon',{name:salesDetails.userName, location: salesDetails.location})}}
          </p>
          <p class="bidder-detail-closed" v-else-if="salesDetails.userName">
            <img src="../../../assets/images/detail/ic_medal.svg" alt="profile-image" />
            {{$t('userWonWithoutLoc',{name:salesDetails.userName})}}
          </p>
        </div>
        <p class="prod-name">{{salesDetails.itemDescription}}</p>
        <span class="bidding-applied">
          {{$t('totalUserApplied')}} :
          <strong>{{salesDetails.totalUser}}</strong>
        </span>
        <span class="bidding-price" v-if="salesDetails.highestBidValue > 0">
          <img src="../../../assets/images/detail/bidding-icon.svg" alt="profile-image" />
          <span>{{Math.round(salesDetails.highestBidValue)}}</span>
          <img
            src="../../../assets/images/detail/m-cash.svg"
            alt
            class="mpoint"
            v-if="salesDetails.biddingCurrencyType === 'MPOINTS'"
          />
          <img
            src="../../../assets/images/detail/gems.svg"
            alt
            class="mpoint"
            v-if="salesDetails.biddingCurrencyType === 'GEMS'"
          />
        </span>
      </div>
      <p class="bidding-time" v-if="salesDetails.biddingStatus === 'INACTIVE'">
        {{$t('bidStartTime')}} :
        <strong>
          <Timer :timing="getLiveTime(salesDetails.biddingStartTimeMillis)" />
        </strong>
      </p>
      <p class="bidding-time" v-if="salesDetails.biddingStatus === 'STARTED'">
        {{$t('timeLeft')}} &nbsp;
        <strong>
          <Timer :timing="getLiveTime(salesDetails.biddingEndTimeMillis)" />
        </strong>
      </p>
      <p
        class="bidding-time"
        v-if="salesDetails.biddingStatus === 'CLOSED'"
        style="visibility:hidden"
      >
        <strong>{{$t('biddingOver')}}</strong>
      </p>
      <div class="bidding-button" v-if="salesDetails.biddingStatus === 'STARTED'">
        <span
          class="view-icon"
          @click="isActivePopUp = !isActivePopUp"
          v-if="salesDetails.totalUser > 0"
        >
          <img src="../../../assets/images/detail/view.svg" />
        </span>
        <button
          type="button"
          class="red-button bidding-now"
          @click="enterAmountPopUp = !enterAmountPopUp"
        >{{$t('biddingNow')}}</button>
      </div>
      <div class="bidding-button" v-if="salesDetails.biddingStatus === 'CLOSED'">
        <span class="view-icon" @click="isActivePopUp = !isActivePopUp">
          <img src="../../../assets/images/detail/view.svg" />
        </span>
        <button
          type="button"
          class="red-button bidding-now"
          style="opacity:0.5"
        >{{$t('biddingOver')}}</button>
      </div>
      <div class="bidding-button" v-if="salesDetails.biddingStatus === 'INACTIVE'">
        <button
          type="button"
          class="red-button bidding-now"
          style="opacity:0.5"
        >{{$t('bidNotStarted')}}</button>
      </div>
      </section>
      <div class="side_popup" :class="{'activeModelCnt' : isActivePopUp, 'minHeight': noShareList}">
        <BiddingViewList v-if="isActivePopUp" @closePopUp="funcClosePopUp" />
      </div>
      <div class="bottomToUp" v-if="enterAmountPopUp"></div>
      <div class="middle_popup" :class="{'popUp' : enterAmountPopUp}">
        <div>
          <h4 class="prdt_hdng">{{$t('enterBiddingAMount')}}</h4>
          <div class="amount-detail">
            <div class="enter-amount">
              <input
                type="number"
                :placeholder="Math.round(salesDetails.nextBidValue)"
                v-model="enterBidAmount"
              />
            </div>
            <div class="red-button" @click="biddingNow(enterBidAmount)">{{$t('enterSumbit')}}</div>
          </div>      
          <h5 class="enter-amount-text">{{$t('maxBiddingValue')}} : <span><img src="../../../assets/images/detail/bidding-icon.svg" alt="profile-image" /> {{Math.round(salesDetails.maxBidValue)}}</span> </h5>
          <h5 class="enter-amount-text" v-if="salesDetails.biddingCurrencyType === 'GEMS'">{{$t('yourTotalBalance',{currencyType:'Gems'})}} : <span><img src="../../../assets/images/detail/gems.svg" alt="profile-image" /> {{Math.round(salesDetails.userGemsBalance)}}</span></h5>
          <h5 class="enter-amount-text" v-if="salesDetails.biddingCurrencyType === 'MPOINTS'">{{$t('yourTotalBalance',{currencyType:'MPoints'})}} : <span><img src="../../../assets/images/detail/m-cash.svg" alt="profile-image" /> {{Math.round(salesDetails.userMpointBalance)}}</span></h5>          
        </div>
        <span class="closePopUp" @click="enterAmountPopUp =!enterAmountPopUp">
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
            <path
              fill="#CDCDCD"
              fill-rule="nonzero"
              d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
              opacity=".675"
            />
          </svg>
        </span>
      </div>
      <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
      <div class="loader" v-if="loading">
        <img src="../../../assets/images/loader.gif" alt="loader" />
      </div>
      <div class="bottomToUp" v-if="bidProcessing"></div>
      <div class="middle_popup bid-processing" :class="{'popUp' : bidProcessing}">
      <img
            src="../../../assets/images/icons/mall-loading.svg"
            class="payTmIcon"
            alt="waiting-icon"
            />
            <span class="loading">Submitting your bid...</span>
            <span class="closePopUp" @click="bidProcessing =!bidProcessing">
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
            <path
              fill="#CDCDCD"
              fill-rule="nonzero"
              d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
              opacity=".675"
            />
          </svg>
        </span>
      </div>
    
  </div>
</template>

<script>
import NoDataFound from "../../../components/Common/NoDataFound";
import ApiCaller from "../../../utils/apicaller";
import constant from "../../../utils/constant";
import Timer from "../../../components/Common/TimeCount";
import CustomToaster from "../../Common/CustomToaster";
import BiddingViewList from "./BiddingViewList";

export default {
  name: "BiddingDetail",
  components: {
    CustomToaster,
    Timer,
    BiddingViewList
  },
  data() {
    return {
      loading: true,
      isActivePopUp: false,
      enterAmountPopUp: false,
      bidProcessing: false,
      salesDetails: {},
      availableLuckyUserIndex: 0,
      clickUserList: [],
      noShareList: false,
      enterBidAmount: "",
      toasterData: {},
      isValidDetail: false,
      noData: false,
      timerId: null,
      intervalCount: 0,
      bidIntervalId: 0,
      bidIntervalCount: 0,
      bidIntervalCountTime: 15,
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getLiveTime(value) {
      let milliseconds = Number(value) / 1000;
      return milliseconds;
    },
    timerStop(obj) {
      if (this.liveData.length > 0) {
        this.liveData[obj.index].status = false;
      }
    },
    funcClosePopUp() {
      this.isActivePopUp = false;
    },
    getAdsSaleDetail() {
      // this.loading = true;
      ApiCaller(
        constant.GAMING_API_URL,
        "get-item-info-by-biddingId/" + this.$route.params.saleReferenceID,
        "get"
      )
        .then(data => {
          this.loading = false;
          if (data.data) {
            this.salesDetails = data.data;
            this.enterBidAmount = Math.round(this.salesDetails.nextBidValue);
          }
        })
        .catch(err => {
          this.loading = false
           if (
                  err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
                  err.response.data.message ==
                    "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
                ){
                  
                  try {
                  _JWT.refereshToken = res => {
                    if (res != "fail") {
                      this.$cookie.set("JWT-TOKEN", res);
                      this.getAdsSaleDetail()
                    } else {
                      this.loading = false;
                    }
                  };
                  JSBridgePlugin.refreshTokens("_JWT.refereshToken");
                } catch (err) {
                  this.loading = false;
                  console.log(err);
                }
                }  
          console.log(err);
        });
    },
    getBidStatus(enterValue){
      if (this.bidIntervalCount >= this.bidIntervalCountTime) {
        clearInterval(this.bidIntervalId);
      } else {

        this.bidIntervalId = setInterval(() => {
          if (this.bidIntervalCount >= this.bidIntervalCountTime) {
            clearInterval(this.bidIntervalId);
            this.bidProcessing = false
            this.toasterData = {
                msg: 'कुछ गलत हो गया है। कृपया कुछ देर बाद प्रयास करें ।',
                color: "red",
                iconName: "check"
              };
            this.isValidDetail = true;
          }
          this.bidIntervalCount++;
          const obj = {
            biddingId: this.salesDetails.biddingId,
            biddingValue: enterValue
          }
          ApiCaller(
            constant.GAMING_API_URL,
            `check-my-bidding-status`,
            "post",
            obj
          ).then((data) => {
            if (data.data.requestStatus != null) {
              if (data.data.requestStatus == "RETRY") {
              } else if (
                ["SUCCESS"].includes(
                  data.data.requestStatus
                )
              ) {
                this.bidProcessing = false
                this.toasterData = {
                    msg: 'Your bid is successfully submitted',
                    color: "green",
                    iconName: "check"
                  };
                this.isValidDetail = true;
                this.getAdsSaleDetail();
                clearInterval(this.bidIntervalId);
              }else if (
                ["FAIL"].includes(
                  data.data.requestStatus
                )
              ) {
                this.bidProcessing = false
                this.toasterData = {
                    msg: 'आप से पहले एक बोली प्रोसेस हो चुकी है दोबारा ऊँची बोली लगायैं',
                    color: "red",
                    iconName: "check"
                  };
                this.isValidDetail = true;
                this.getAdsSaleDetail();
                clearInterval(this.bidIntervalId);
              }
            } else {
              clearInterval(this.bidIntervalId);
            }
          }).catch(err=>{
            this.bidProcessing = false
            clearInterval(this.bidIntervalId);
            if (
                  err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
                  err.response.data.message ==
                    "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
                ){
                  try {
                  _JWT.refereshToken = res => {
                    if (res != "fail") {
                      this.$cookie.set("JWT-TOKEN", res);
                      this.getBidStatus(enterValue)
                    } else {
                      this.loading = false;
                    }
                  };
                  JSBridgePlugin.refreshTokens("_JWT.refereshToken");
                } catch (err) {
                  this.loading = false;
                  console.log(err);
                }
                } 
          })
        }, 5000);
      }
    },
    biddingNow(enterValue) {
      if (this.salesDetails.biddingCurrencyType === "MPOINTS") {
        if (this.enterBidAmount == "") {
          enterValue = this.salesDetails.nextBidValue;
        }
        if (parseFloat(enterValue) <= this.salesDetails.userMpointBalance) {
          if (
            parseFloat(enterValue) <= this.salesDetails.maxBidValue &&
            parseFloat(enterValue) >= this.salesDetails.nextBidValue
          ) {
            this.loading = true;

            const obj = {
              biddingId: this.salesDetails.biddingId,
              biddingValue: enterValue
            };
            ApiCaller(constant.GAMING_API_URL, "create/bid", "post", obj)
              .then(data => {
                if (data.data.requestStatus === "SUCCESS") {
                  this.enterAmountPopUp = false;
                  this.noShareList = false;
                  this.toasterData = {
                    msg: 'आपकी बिड ले ली गयी है - जब प्रोसेस हो जायेगी तो आपको नोटिफिकेशन भेजेंगे।',
                    color: "orange",
                    iconName: "check"
                  };
                  this.isValidDetail = true;
                  this.getAdsSaleDetail();
                  // this.timerId = setInterval(() => {
                  //   this.intervalCount++;
                  //   this.getAdsSaleDetail();
                  // },5000)
                }
              })
              .catch(err => {
                this.loading = false;
                if (
                  err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
                  err.response.data.message ==
                    "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
                ){
                  
                  try {
                  _JWT.refereshToken = res => {
                    if (res != "fail") {
                      this.$cookie.set("JWT-TOKEN", res);
                      this.biddingNow(enterValue)
                    } else {
                      this.loading = false;
                    }
                  };
                  JSBridgePlugin.refreshTokens("_JWT.refereshToken");
                } catch (err) {
                  this.loading = false;
                  console.log(err);
                }
                }  else if (
                  err.response.data.errorCodes[0] == "INVALID_BIDDING_VALUE"
                ){
                  this.toasterData = {
                    msg: 'आप से पहले एक बोली प्रोसेस हो चुकी है दोबारा ऊँची बोली लगायैं',
                    color: "red",
                    iconName: "check"
                  };
                  this.isValidDetail = true;
                }               
                console.log(err);
              });
          } else {
            this.toasterData = {
              msg: this.$t("cannotEnterMaxBidAmount", {
                maxBidValue: Math.round(this.salesDetails.maxBidValue),
                highestBidValue: Math.round(this.salesDetails.nextBidValue),
                currencyType: 'MPoints'
              }),
              color: "#E51C24",
              iconName: "check"
            };
            this.isValidDetail = true;
          }
        } else {
          this.toasterData = {
            msg: this.$t("insufficientValue", {
              mPoint: Math.round(this.salesDetails.userMpointBalance),
              currencyType : 'MPoints'
            }),
            color: "#E51C24",
            iconName: "check"
          };
          this.isValidDetail = true;
        }
      }
      if (this.salesDetails.biddingCurrencyType === "GEMS") {
        if (this.enterBidAmount == "") {
          enterValue = this.salesDetails.nextBidValue;
        }
        if (parseFloat(enterValue) <= this.salesDetails.userGemsBalance) {
          if (
            parseFloat(enterValue) <= this.salesDetails.maxBidValue &&
            parseFloat(enterValue) >= this.salesDetails.nextBidValue
          ) {
            this.loading = true;
            const obj = {
              biddingId: this.salesDetails.biddingId,
              biddingValue: enterValue,
              sellerItemRelationShipId: this.salesDetails.sellerItemRelationShipId
            };
            ApiCaller(constant.GAMING_API_URL, "create/bid", "post", obj)
              .then(data => {
                if (data.data.requestStatus === "SUCCESS") {
                  this.loading = false
                  this.enterAmountPopUp = false;
                  this.noShareList = false;
                  this.bidProcessing = true;
                  this.getBidStatus(enterValue)
                }
              })
              .catch(err => {
                this.loading = false;
                if (
                  err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
                  err.response.data.message ==
                    "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
                ){
                  try {
                  _JWT.refereshToken = res => {
                    if (res != "fail") {
                      this.$cookie.set("JWT-TOKEN", res);
                      this.biddingNow(enterValue)
                    } else {
                      this.loading = false;
                    }
                  };
                  JSBridgePlugin.refreshTokens("_JWT.refereshToken");
                } catch (err) {
                  this.loading = false;
                  console.log(err);
                }
                } else if (
                  err.response.data.errorCodes[0] == "INVALID_BIDDING_VALUE"
                ){
                  this.toasterData = {
                    msg: 'आप से पहले एक बोली प्रोसेस हो चुकी है दोबारा ऊँची बोली लगायैं',
                    color: "red",
                    iconName: "check"
                  };
                  this.isValidDetail = true;
                }  
                console.log(err);
              });
          } else {
            this.toasterData = {
              msg: this.$t("cannotEnterMaxBidAmount", {
                maxBidValue: Math.round(this.salesDetails.maxBidValue),
                highestBidValue: Math.round(this.salesDetails.nextBidValue),
                currencyType: 'Gems'
              }),
              color: "#E51C24",
              iconName: "check"
            };
            this.isValidDetail = true;
          }
        } else {
          this.toasterData = {
            msg: this.$t("insufficientValue", {
              mPoint: Math.round(this.salesDetails.userGemsBalance),
              currencyType: 'Gems'
            }),
            color: "#E51C24",
            iconName: "check"
          };
          this.isValidDetail = true;
        }
      }
    },

    shareFunc(shareImage, saleReferenceID, bidId) {
      if (this.$cookie.get("X-Auth-Id") != null) {
        this.loading = true;
        // this.$store
        //   .dispatch({
        //     type: "getShareDetailsByItem",
        //     payload: saleReferenceID + "?type=BIDDING-" + bidId
        //   })
          ApiCaller(
          constant.LOCAL_SHOP_URL,
          `get-share-details/${saleReferenceID}?type=BIDDING&biddingId=${bidId}`,
          "get"
        )
          .then(data => {
            this.shareLinkData = data.data;
            this.loading = false;
            const obj = {
              message: data.data.shareMessage,
              imageUrl: shareImage
            };
            try {
              JSBridgePlugin.share(JSON.stringify(obj));
            } catch (err) {
              console.log(err);
              window.open("whatsapp://send?text=" + data.data.shareMessage);
            }
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
          });
      } else {
        try {
          _prompt_login.promptLogin = res => {
            if (res == "success") {
              console.log(res);
            } else {
              this.loading = false;
            }
          };
          JSBridgePlugin.promptLogin("_prompt_login.promptLogin");
        } catch (err) {
          this.loading = false;
          console.log(err);
        }
      }
    }
  },
  beforeDestroy(){
    clearInterval(this.timerId);
    clearInterval(this.bidIntervalId);
  },
  mounted() {
    this.getAdsSaleDetail();
    this.timerId = setInterval(() => {
      this.intervalCount++;
      this.getAdsSaleDetail();
    },5000)
  }
};
</script>
<style lang="scss" scoped>
.middle_popup,.bottomToUp{
  transition:none
}
.bid-processing{
      text-align: center;
    align-items: center;
    /* display: flex; */
    width: 55%;
    min-height: 50px;
    .loading{
      display: block;
    }
}
.bidder-detail {
  // margin-top: -30px;
  // margin-bottom: 8px;
  display: flex;
  background: #e81f1f;
  color: #fff;
  border-radius: 15px;
  padding: 2px 10px;
  text-align: center;
  font-size: 0.75em;
  /* margin-top: 8px; */
  width: fit-content;
  margin: -30px auto 8px;
  animation-name: myfirst;
  animation-duration: 5s;
  animation-timing-function: linear;
  animation-delay: 0s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-play-state: running;
  align-items: center;
  line-height: 1.5;
}
.bidder-detail-closed {
  background: #4caf50;
  color: #fff;
  border-radius: 15px;
  padding: 2px 10px;
  text-align: center;
  font-size: 0.75em;
  width: fit-content;
  margin: -30px auto 8px;
  align-items: center;
  line-height: 1.5;
  display: flex;
  img {
    width: 17px;
  }
}
@keyframes myfirst {
  0% {
    background: #e81f1f;
    left: 0px;
    top: 0px;
  }

  25% {
    background: #00bb4d;
    left: 0px;
    top: 0px;
  }

  50% {
    background: #e81f1f;
    left: 0px;
    top: 0px;
  }

  75% {
    background: #e9af04;
    left: 0px;
    top: 0px;
  }

  100% {
    background: #e81f1f;
    left: 0px;
    top: 0px;
  }
}

.side_popup.activeModelCnt {
  transform: translateX(0);
  opacity: 1;
}
.side_popup {
  width: 100%;
  height: 100%;
  position: fixed;
  background: #fff;
  z-index: 11;
  left: 0;
  top: 0;
  text-align: left;
  transition: all ease-in-out 0.2s;
  opacity: 0.1;
  transform: translateX(100%);
}
header {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  align-items: center;
  width: 100%;
  // position: fixed;
  // top: 0;
  // z-index: 9;
}
.share-button {
  border: 0;
  background: #00bb4d;
  padding: 6px 20px;
  font-size: 0.875em;
  border-radius: 15px;
  color: #fff;
  font-weight: 600;
}
.detail-content {
  position: relative;
}
.winner-button {
  border: 1.3px solid #ff4b00;
  width: fit-content;
  padding: 5px 10px;
  border-radius: 5px;
  color: #ff4b00;
  font-weight: 600;
  display: flex;
  align-items: center;
  font-family: "Roboto", sans-serif;
}
.img-block {
  height: 382px;
  position: relative;
  img {
    max-height: 100%;
    max-width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.prod-detail {
  padding: 15px;
  position: relative;
  .prod-name {
    color: #262626;
    font-size: 1.25em;
    font-weight: 500;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.5;
  }
  .bidding-applied {
    color: #898989;
    font-size: 0.813em;
    margin: 8px 0;
    display: block;
  }
  .bidding-price {
    background: #fc402c12;
    padding: 10px 15px;
    font-size: 1.25em;
    color: #e81f1f;
    font-weight: 600;
    border-radius: 15px;
    display: block;
    margin: 8px 0;
    width: fit-content;
    display: flex;
    align-items: center;
    img {
      width: 17px;
    }
    .mpoint {
      width: 24px;
    }
    span {
      padding: 0 8px;
    }
  }
}
.bidding-time {
  font-size: 0.875em;
  color: #898989;
  padding: 0 15px;
  text-align: right;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 28px;
  strong {
    color: #00bb45;
  }
}
.red-button {
  background: #e81f1f;
  color: #fff;
  font-weight: 600;
  border: 0;
  padding: 13px 25px;
  border-radius: 15px;
  font-size: 1em;
  width: 40%;
  text-align: center;
}
.bidding-button {
  padding: 15px;
  padding: 0 15px 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -15px;

  .bidding-now {
    width: 78%;
  }
  .view-icon {
    padding: 13px 15px;
    border-radius: 15px;
    background: #89898961;
    line-height: 0;
    margin-right: 14px;
  }
}
.noShareList {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  width: 80%;
  text-align: center;
  font-weight: 600;
}
.minHeight {
  min-height: 60px;
  text-align: center;
}
.enter-amount-text {
  font-size: 0.875em;
  color: #898989;
  margin:10px;
  display: flex;
  span{
    display: flex;
    align-items: center;
    img{
      padding: 0 5px;
          width: 30px;
    }
  }
}
.amount-detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 15px 0 8px;
  .enter-amount {
    margin-right: 10px;
    width: 60%;
    input {
      background: #f8f8f8;
      padding: 13px;
      border-radius: 15px;
      font-size: 1em;
    }
  }
}
</style>